import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo, useRef } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
export function useMemoFromPropsDerivative(factory, propsDerivator, props) {
  // cache the last set of props
  var prev = useRef(props);
  var prevFactory = useRef(null);
  return useMemo(function () {
    if (fg('cc_complexit_fe_reduce_fragment_serialization')) {
      // check if the serializer is already created
      var shouldCreate = !prevFactory.current;
      // check each prop to see if value has changed and also check if the number of props has changed
      if (prev.current !== props) {
        var propsEntries = Object.entries(props);
        shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            prop = _ref2[1];
          return prev.current[key] !== prop;
        });
      }
      prev.current = props;
      // If first time or any prop value has changed, create a new serializer
      if (shouldCreate) {
        prevFactory.current = factory(propsDerivator(props));
      }
      return prevFactory.current;
    }
    return factory(propsDerivator(props));
  },
  // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [propsDerivator, props]);
}